import { TrashFilled } from '@aircall/icons';
import { Button, ThemeProvider } from '@aircall/tractor-v2';
import { AgentDeleteConfirmationModal } from '@components/AgentDeleteConfirmationModal/AgentDeleteConfirmationModal';
import { USERS_ROUTE } from '@constants/routes.constants';
import { UserFullFragment, UserFullFragment_roles } from '@generated/UserFullFragment';
import { useDeleteUser } from '@hooks/useDeleteUser';
import { useToggle } from '@hooks/useToggle/useToggle';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

interface DeleteUserModalContainerProps {
  user: UserFullFragment;
  roles?: UserFullFragment_roles[];
}

/* istanbul ignore next */
export function DeleteUserModalContainer({ user, roles = [] }: DeleteUserModalContainerProps) {
  const { t } = useTranslation();
  const [isDeleteUserModalOpen, _, setDeleteUserModalOpen, setDeleteUserModalClose] = useToggle();

  const navigate = useNavigate();
  const handleCompleted = () => navigate(USERS_ROUTE, { replace: true });
  const { isDeleteLoading, deleteError, onSubmit } = useDeleteUser({
    userId: parseInt(user.ID),
    onCompleted: handleCompleted,
  });

  const { firstName, lastName, pictureURL, isActive, ID } = user;

  return (
    <ThemeProvider>
      <Button
        onClick={setDeleteUserModalOpen}
        mode='outline'
        variant='critical'
        data-test='user-profile-delete-button'
      >
        <TrashFilled />
        {t('users.delete_user.delete_button')}
      </Button>
      <AgentDeleteConfirmationModal
        deleteError={deleteError}
        isDeleteDisabled={false}
        isDeleteLoading={isDeleteLoading}
        isModalOpen={isDeleteUserModalOpen}
        onCancelClick={setDeleteUserModalClose}
        onDeleteClick={onSubmit}
        idToDelete={ID}
        firstNameToDelete={firstName}
        lastNameToDelete={lastName}
        pictureURLToDelete={pictureURL}
        rolesToDelete={roles}
        isActiveToDelete={isActive}
      />
    </ThemeProvider>
  );
}
